import { Navigate, Outlet, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { AgentProvider, useAgent } from '../../contexts/AgentContext';
import { usePostMessageListener } from '../../hooks/usePostMessageListener';
import { isJwtTokenExpired } from '../../services/api-service';
import { clearSession, isLoggedIn } from '../../services/auth-service';
import { getDefaultPostLoginRoute } from '../../services/navigation-service';
import ContactAdmin from '../ContactAdmin/ContactAdmin';
import ForgotPassword from '../ForgotPassword/ForgotPassword';
import Login from '../Login/Login';
import ResetPasswordNew from '../Login/ResetPasswordNew';
import SsoLogin from '../Login/SsoLogin';
import ResetPassword from '../ResetPassword/ResetPassword';
import '../Wireframe/Wireframe.css';
import WireframeDashboard from '../WireframeDashboard/WireframeDashboard';
function Wireframe() {


	const LoginPage = () => {
		let matches = false
		try {
			matches = window.location.href.includes('dishtv') || false;
		} catch {
			matches = false
		}
		return matches ? <SsoLogin /> : <Login />;
	}

	return (
		<AgentProvider>
			<Router basename="/">
				<WireframeContent LoginPage={LoginPage} />
			</Router>
		</AgentProvider>
	);
}

function WireframeContent({ LoginPage }: { LoginPage: React.ComponentType }) {
	const { handleAgentLogin, handleAgentLogout } = useAgent();

	// Set up the postMessage listener to track agent login/logout
	usePostMessageListener({
		onLogin: handleAgentLogin,
		onLogout: handleAgentLogout,
		onMessage: (data) => {
			console.log('PostMessage received:', data);
		}
	});

	return (
		<Routes>
			<Route path="/" element={<Navigate to="/login" />} />
			<Route path={`/login`} element={<AuthRoute />}>
				<Route path={`/login`} element={<LoginPage />} />
			</Route>
			<Route path={`/forgot-password`} element={<ForgotPassword />} />
			<Route path={`/reset-password`} element={<ResetPassword />} />
			<Route path={`/contact-admin`} element={<ContactAdmin />} />
			<Route path={`/resetpassword`} element={<ResetPasswordNew />} />
			<Route path={`*`} element={<PrivateRoute />}>
				<Route path={`*`} element={<WireframeDashboard />}></Route>
			</Route>
		</Routes>
	);
}

export default Wireframe;

function PrivateRoute({ children, ...rest }: any) {
	const isUserLoggedIn = isLoggedIn();
	const isTokenExpired = isJwtTokenExpired();
	const isUserAuthorized = isUserLoggedIn && !isTokenExpired;
	if (isUserAuthorized) {
		return <Outlet />;
	} else {
		clearSession();
		return <Navigate to="/login" />;
	}
}

function AuthRoute({ children, ...rest }: any) {
	const isUserLoggedIn = isLoggedIn();
	const isTokenExpired = isJwtTokenExpired();
	const isUserAuthorized = isUserLoggedIn && !isTokenExpired;
	if (isUserAuthorized) {
		return <Navigate to={getDefaultPostLoginRoute()} />;
	} else {
		clearSession();
		return <Outlet />;
	}
}
